import { DescriptionBlock } from '../../../../shared/ui/DescriptionBlock/DescriptionBlock';
import { AnimatePresence, LayoutGroup, motion } from "framer-motion";

interface IResetPasswordDescriptionProps {
    showDescription: boolean;
}

export function ResetPasswordDescription({ showDescription }: IResetPasswordDescriptionProps) {
    return (
        <LayoutGroup>
            <AnimatePresence>
            {showDescription && (
                <motion.div
                layout
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: 'auto' }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.5 }}
                style={{ overflow: 'hidden' }}
                >
                    <DescriptionBlock>
                        Если адрес зарегистрирован, мы отправили письмо с инструкциями. Проверьте входящие и «Спам».
                    </DescriptionBlock>
                </motion.div>
            )}
            </AnimatePresence>
        </LayoutGroup>
    )
}